<template>
    <div class="m-portlet m-portlet--mobile" :class="className">
        <div class="m-portlet__head"  v-if="title">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text" >
                        {{ title }}
                        <small v-if="subtitle">
                            {{ subtitle }}
                        </small>
                    </h3>
                </div>

            </div>
            <div class="m-portlet__head-tools actions">

                <slot name="header"></slot>

                <slot name="translations"></slot>

            </div>

        </div>
        <div class="m-portlet__body">

            <div class="form-body">
                <slot></slot>
            </div>

        </div>
    </div>

</template>
<style>
    .portlet>.portlet-title>.nav-tabs{
        margin-right:20px;
    }
</style>
<script>
export default {
    props: {
        title: String,
        subtitle: String,
        className: {
            default: 'light bordered',
            type: String
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/Block.vue